import { useContext } from 'react';
import { Context } from '../Context';
export function useUploadFileSystemDocument() {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useUploadFileSystemDocument hook used outside <UploadFileSystemDocumentProvider />');
    }
    return context;
}
